import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { SyntheticEvent, useState } from "react";
import { useTranslation } from "react-i18next";

import { InboundDeliveryFragment } from "../../../../models/autogenerated-deliveryService-gql/graphql";
import DetailsDocumentsTab from "../detailsTabs/detailsDocumentsTab/DetailsDocumentsTab";
import DetailsItemsTab from "../detailsTabs/detailsItemsTab/DetailsItemsTab";
import DetailsStatusTab from "../detailsTabs/detailsStatusTab/DetailsStatusTab";
import DetailsTimesTab from "../detailsTabs/detailsTimesTab/DetailsTimesTab";
import "./DetailsTabCard.scss";

interface DetailsTabCardProps {
  delivery: InboundDeliveryFragment;
}

const tabs = ["items", "documents", "times", "status"];

const DetailsTabCard = (props: DetailsTabCardProps) => {
  const { t } = useTranslation();
  const { delivery } = props;
  const { items, documents, times } = delivery;
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleChange = (event: SyntheticEvent, index: number) => {
    setActiveTab(index);
  };

  return (
    <Box data-testid="detailsTabCard">
      <TabContext value={activeTab}>
        <Box>
          <TabList variant="fullWidth" onChange={handleChange}>
            {tabs.map((tab, index) => {
              return <Tab key={index} label={t(tab)} value={index} />;
            })}
          </TabList>
        </Box>
        <TabPanel value={0}>
          <DetailsItemsTab items={items} />
        </TabPanel>
        <TabPanel value={1}>
          <DetailsDocumentsTab documents={documents} />
        </TabPanel>
        <TabPanel value={2}>
          <DetailsTimesTab times={times} />
        </TabPanel>
        <TabPanel value={3}>
          <DetailsStatusTab delivery={delivery} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default DetailsTabCard;
